/*
 * Значения для messageBox по умолчанию
 */
let messageData = {
    // Заголовок окна
    messageTitle: messageBoxTrans.title,
    // Текст в окне
    messageText: '',
    // Текст на кнопке OK. Если указать пустое место - кнопки не будет
    okText: messageBoxTrans.ok_caption,
    // Текст на кнопке Cancel. Если указать пустое место - кнопки не будет
    cancelText: messageBoxTrans.cancel_caption,
    // Функция, вызываемая при нажатии ОК
    okCallback: null,
    // Объект, подставляемый как параметр в функцию при нажатии ОК
    okCallbackParamObject: null,
    // Функция, вызываемя при нажатии Cancel (может вообще не надо)
    cancelCallback: null,
    // Объект, подставляемый при нажатии Cancel
    cancelCallbackParamObject: null,
    // Дополнительный класс, приписываемый к div.modal. У нас в Б24 немного различается верстка
    context: appContext,
};

module.exports = messageData;

